var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              height: "32px",
              "margin-left": "16px",
              "padding-top": "32px",
            },
          },
          [
            _c("div", { staticClass: "title-line" }),
            _c("div", { staticClass: "title-name" }, [
              _vm._v(_vm._s(_vm.titleName)),
            ]),
          ]
        ),
        _c("div", { staticClass: "main1" }, [
          _c(
            "div",
            { staticClass: "panel-block flex" },
            [
              _c(
                "div",
                { staticClass: "panel-left" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      staticClass: "form",
                      attrs: {
                        inline: true,
                        model: _vm.form,
                        size: "small",
                        "label-width": "90px",
                        disabled: _vm.isLook,
                        rules: _vm.rules,
                        "label-position": "right",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "anchor-0",
                          staticClass: "panel-item anchor-item",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "panel-item-title panel-item-title-1",
                            },
                            [_vm._v("基础信息")]
                          ),
                          _c(
                            "div",
                            { staticClass: "panel-item-content" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "label-star",
                                  attrs: {
                                    label: "招聘信息来源",
                                    prop: "recruitOrigin",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "custom-label" },
                                            [
                                              _vm._v("招聘信息"),
                                              _c("br"),
                                              _vm._v("来源"),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.recruitOrigin,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "recruitOrigin",
                                            $$v
                                          )
                                        },
                                        expression: "form.recruitOrigin",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.recruit_origin,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "应聘部门", prop: "orgCode" },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changePosition($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.form.orgCode,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "orgCode", $$v)
                                        },
                                        expression: "form.orgCode",
                                      },
                                    },
                                    _vm._l(_vm.positions, function (item) {
                                      return _c("el-option", {
                                        key: item.orgCode,
                                        attrs: {
                                          label: item.orgName,
                                          value: item.orgCode,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "应聘职位",
                                    prop: "recruitPost",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.recruitPost,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "recruitPost", $$v)
                                        },
                                        expression: "form.recruitPost",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.recruit_post,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "可到岗日期",
                                    prop: "availableTime",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: "请选择年/月/日",
                                    },
                                    model: {
                                      value: _vm.form.availableTime,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "availableTime", $$v)
                                      },
                                      expression: "form.availableTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "姓名", prop: "name" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v("姓"),
                                          _c("span", { staticClass: "space" }),
                                          _vm._v("名"),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "8",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "name", $$v)
                                      },
                                      expression: "form.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "性别", prop: "gender" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v("性"),
                                          _c("span", { staticClass: "space" }),
                                          _vm._v("别"),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "el-input",
                                      model: {
                                        value: _vm.form.gender,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "gender", $$v)
                                        },
                                        expression: "form.gender",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("男"),
                                      ]),
                                      _c("el-radio", { attrs: { label: 2 } }, [
                                        _vm._v("女"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "籍贯", prop: "nativePlace" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v("籍"),
                                          _c("span", { staticClass: "space" }),
                                          _vm._v("贯"),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "12",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.nativePlace,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "nativePlace", $$v)
                                      },
                                      expression: "form.nativePlace",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "民族", prop: "nation" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v("民"),
                                          _c("span", { staticClass: "space" }),
                                          _vm._v("族"),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "12",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.nation,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "nation", $$v)
                                      },
                                      expression: "form.nation",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "身高(cm)", prop: "height" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "3",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.height,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "height", $$v)
                                      },
                                      expression: "form.height",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "体重(kg)", prop: "weight" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "3",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.weight,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "weight", $$v)
                                      },
                                      expression: "form.weight",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "属相", prop: "zodiac" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v("属"),
                                          _c("span", { staticClass: "space" }),
                                          _vm._v("相"),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.zodiac,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "zodiac", $$v)
                                        },
                                        expression: "form.zodiac",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.zodiac,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "最高学历",
                                    prop: "educationalLevel",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.educationalLevel,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "educationalLevel",
                                            $$v
                                          )
                                        },
                                        expression: "form.educationalLevel",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.educational_level,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "身份证号码",
                                    prop: "idCardNumber",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "18",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.idCardNumber,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "idCardNumber", $$v)
                                      },
                                      expression: "form.idCardNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "期待工资",
                                    prop: "desiredSalary",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "6",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.desiredSalary,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "desiredSalary",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "form.desiredSalary",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "爱好/专长", prop: "hobby" },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "20",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.hobby,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "hobby", $$v)
                                      },
                                      expression: "form.hobby",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "label-star",
                                  attrs: {
                                    label: "汽(机)车驾照",
                                    prop: "drivingLicenseLevel",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "custom-label" },
                                            [
                                              _vm._v("汽(机)车"),
                                              _c("br"),
                                              _vm._v("驾照"),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.drivingLicenseLevel,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "drivingLicenseLevel",
                                            $$v
                                          )
                                        },
                                        expression: "form.drivingLicenseLevel",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.driving_license_level,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "出生日期",
                                    prop: "dateOfBirth",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      type: "date",
                                      placeholder: "请选择年/月/日",
                                    },
                                    model: {
                                      value: _vm.form.dateOfBirth,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "dateOfBirth", $$v)
                                      },
                                      expression: "form.dateOfBirth",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "联系电话", prop: "phone" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      maxlength: "11",
                                      clearable: "",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.form.phone,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "phone", $$v)
                                      },
                                      expression: "form.phone",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "微信号",
                                    prop: "wechatNumber",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.wechatNumber,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "wechatNumber", $$v)
                                      },
                                      expression: "form.wechatNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "邮箱地址", prop: "email" } },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.form.email,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "email", $$v)
                                      },
                                      expression: "form.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "政治面貌",
                                    prop: "politicalAffiliation",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.politicalAffiliation,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "politicalAffiliation",
                                            $$v
                                          )
                                        },
                                        expression: "form.politicalAffiliation",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.political_affiliation,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "婚姻状况",
                                    prop: "maritalStatus",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.maritalStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "maritalStatus",
                                            $$v
                                          )
                                        },
                                        expression: "form.maritalStatus",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.marital_status,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "户口性质",
                                    prop: "householdType",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.householdType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "householdType",
                                            $$v
                                          )
                                        },
                                        expression: "form.householdType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.dictionaries.household_type,
                                      function (item) {
                                        return _c("el-option", {
                                          key: item.dictId,
                                          attrs: {
                                            label: item.dictName,
                                            value: item.dictId,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "label-star-1",
                                      attrs: {
                                        label: "身份证详细地址",
                                        prop: "householdResidenceDetail",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "custom-label" },
                                                [
                                                  _vm._v("身份证"),
                                                  _c("br"),
                                                  _vm._v("详细地址"),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "204px" },
                                        attrs: {
                                          placeholder: "请输入",
                                          clearable: "",
                                          maxlength: "32",
                                          type: "textarea",
                                          rows: "3",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value:
                                            _vm.form.householdResidenceDetail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "householdResidenceDetail",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.householdResidenceDetail",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "label-star-1",
                                      attrs: {
                                        label: "居住地详细地址",
                                        prop: "currentResidenceDetail",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "custom-label" },
                                                [
                                                  _vm._v("居住地"),
                                                  _c("br"),
                                                  _vm._v("详细地址"),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "204px" },
                                        attrs: {
                                          placeholder: "请输入",
                                          maxlength: "32",
                                          clearable: "",
                                          type: "textarea",
                                          rows: "3",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value:
                                            _vm.form.currentResidenceDetail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "currentResidenceDetail",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.currentResidenceDetail",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "label-star",
                                      attrs: {
                                        label: "紧急联系人姓名",
                                        prop: "emergencyContactName",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "custom-label" },
                                                [
                                                  _vm._v("紧急联系人"),
                                                  _c("br"),
                                                  _vm._v("姓名"),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入",
                                          maxlength: "8",
                                          clearable: "",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.form.emergencyContactName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "emergencyContactName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.emergencyContactName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "label-star",
                                      attrs: {
                                        label: "紧急联系人电话",
                                        prop: "emergencyContactPhone",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "custom-label" },
                                                [
                                                  _vm._v("紧急联系人"),
                                                  _c("br"),
                                                  _vm._v("电话"),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入",
                                          maxlength: "11",
                                          clearable: "",
                                          "show-word-limit": "",
                                        },
                                        model: {
                                          value: _vm.form.emergencyContactPhone,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "emergencyContactPhone",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "form.emergencyContactPhone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "label-star",
                                  attrs: {
                                    label: "原单位是否存在纠纷",
                                    prop: "disputeFlag",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "custom-label" },
                                            [
                                              _vm._v("原单位是否"),
                                              _c("br"),
                                              _vm._v("存在纠纷"),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "el-input" },
                                    [
                                      _c(
                                        "el-radio-group",
                                        {
                                          model: {
                                            value: _vm.form.disputeFlag,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "disputeFlag",
                                                $$v
                                              )
                                            },
                                            expression: "form.disputeFlag",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 1 } },
                                            [_vm._v("是")]
                                          ),
                                          _c(
                                            "el-radio",
                                            { attrs: { label: 0 } },
                                            [_vm._v("否")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.form.disputeFlag == 1
                                        ? _c("el-input", {
                                            staticClass: "dipute-textarea",
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请输入",
                                              maxlength: "20",
                                              type: "textarea",
                                              rows: "3",
                                              "show-word-limit": "",
                                            },
                                            model: {
                                              value: _vm.form.dispute,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "dispute",
                                                  $$v
                                                )
                                              },
                                              expression: "form.dispute",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "上传近照", prop: "image" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "el-input my-last-photo" },
                                    [
                                      _vm.isLook
                                        ? [
                                            _c("img", {
                                              staticClass: "img",
                                              attrs: { src: _vm.form.image },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handlePictureCardPreview(
                                                    _vm.form.image
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        : [
                                            _c("headerPicture", {
                                              attrs: {
                                                qrCodeUrl: _vm.form.image,
                                              },
                                              on: {
                                                getUrl: function ($event) {
                                                  return _vm.getImage($event)
                                                },
                                              },
                                            }),
                                            _c("div", { staticClass: "tips" }, [
                                              _vm._v(
                                                "（上传图片大小在4M以内，尺寸不限，格式为jpg，png） "
                                              ),
                                            ]),
                                          ],
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "relative" }, [
                                _c(
                                  "div",
                                  { staticClass: "main-colume" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        staticClass: "label-star",
                                        attrs: {
                                          label: "是否有亲戚/朋友在公司",
                                          prop: "kinFlag",
                                          "label-width": "96px",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "custom-label",
                                                  },
                                                  [
                                                    _vm._v("是否有亲戚/"),
                                                    _c("br"),
                                                    _vm._v("朋友在公司"),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ]),
                                      },
                                      [
                                        _c(
                                          "el-radio-group",
                                          {
                                            staticClass: "el-input",
                                            model: {
                                              value: _vm.form.kinFlag,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "kinFlag",
                                                  $$v
                                                )
                                              },
                                              expression: "form.kinFlag",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "1" } },
                                              [_vm._v("是")]
                                            ),
                                            _c(
                                              "el-radio",
                                              { attrs: { label: "0" } },
                                              [_vm._v("否")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.form.kinFlag == 1
                                  ? _c(
                                      "div",
                                      { staticClass: "primary-colume" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "其姓名",
                                              prop: "kinName",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                maxlength: "8",
                                                clearable: "",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: _vm.form.kinName,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "kinName",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.kinName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "关系",
                                              prop: "kinRelationship",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v("关"),
                                                      _c("span", {
                                                        staticClass: "space",
                                                      }),
                                                      _vm._v("系"),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              2359371336
                                            ),
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                maxlength: "8",
                                                clearable: "",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: _vm.form.kinRelationship,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "kinRelationship",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.kinRelationship",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "部门",
                                              prop: "kinOrganization",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _vm._v("部"),
                                                      _c("span", {
                                                        staticClass: "space",
                                                      }),
                                                      _vm._v("门"),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              198431776
                                            ),
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                placeholder: "请输入",
                                                maxlength: "12",
                                                clearable: "",
                                                "show-word-limit": "",
                                              },
                                              model: {
                                                value: _vm.form.kinOrganization,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "kinOrganization",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.kinOrganization",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "line" }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          ref: "anchor-1",
                          staticClass: "panel-item anchor-item",
                        },
                        [
                          _c("div", { staticClass: "panel-item-title" }, [
                            _vm._v("工作履历"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "400",
                                  "font-size": "16px",
                                  color: "#616363",
                                },
                              },
                              [_vm._v("（时间由近至远）")]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "panel-item-content" },
                            [
                              _vm._l(
                                _vm.form.workRecordList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: { "margin-bottom": "24px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sort-index" },
                                            [_vm._v(_vm._s(index + 1))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "sort-title" },
                                            [_vm._v("工作履历")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "26px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "起始日期",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".startTime",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请选择起始日期",
                                                            trigger: "change",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        attrs: {
                                                          type: "date",
                                                          placeholder:
                                                            "请选择年/月/日",
                                                        },
                                                        model: {
                                                          value: item.startTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "startTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.startTime",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "结束日期",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".endTime",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请选择结束日期",
                                                            trigger: "change",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        attrs: {
                                                          type: "date",
                                                          placeholder:
                                                            "请选择年/月/日",
                                                        },
                                                        model: {
                                                          value: item.endTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "endTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.endTime",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "单位名称",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".company",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请输入单位名称",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                          maxlength: "24",
                                                        },
                                                        model: {
                                                          value: item.company,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "company",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.company",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "任职部门",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".organization",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请输入任职部门",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                          maxlength: "12",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value:
                                                            item.organization,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "organization",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.organization",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "担任职位",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".post",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请输入担任职位",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.post,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "post",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.post",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "现离职原因",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".resignationReason",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请选择现离职原因",
                                                            trigger: "change",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              item.resignationReason,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "resignationReason",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.resignationReason",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.dictionaries
                                                            .resignation_reason,
                                                          function (itm) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: itm.dictId,
                                                                attrs: {
                                                                  label:
                                                                    itm.dictName,
                                                                  value:
                                                                    itm.dictId,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "月薪",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".salary",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请输入月薪",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function () {
                                                              return [
                                                                _vm._v("月"),
                                                                _c("span", {
                                                                  staticClass:
                                                                    "space",
                                                                }),
                                                                _vm._v("薪"),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                        },
                                                        model: {
                                                          value: item.salary,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "salary",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.salary",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "证明人",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".certifier",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请输入证明人",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                          maxlength: "8",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value: item.certifier,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "certifier",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.certifier",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "联系电话",
                                                        prop:
                                                          "workRecordList." +
                                                          index +
                                                          ".phone",
                                                        rules: [
                                                          {
                                                            required: true,
                                                            message:
                                                              "请输入联系电话",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          maxlength: "11",
                                                          clearable: "",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value: item.phone,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "phone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.phone",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              !_vm.isLook && index != 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "delete",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deletePlus(
                                                            1,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 删除")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              !_vm.isLook
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPlus(1)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                              staticStyle: { color: "#00B498" },
                                            }),
                                          ]),
                                          _c("div", { staticClass: "btn-t" }, [
                                            _vm._v("添加工作履历"),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "line" }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          ref: "anchor-2",
                          staticClass: "panel-item anchor-item",
                        },
                        [
                          _c("div", { staticClass: "panel-item-title" }, [
                            _vm._v("教育经历"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "400",
                                  "font-size": "16px",
                                  color: "#616363",
                                },
                              },
                              [_vm._v("（学历由高至低）")]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "panel-item-content" },
                            [
                              _vm._l(
                                _vm.form.educationList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: { "margin-bottom": "24px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sort-index" },
                                            [_vm._v(_vm._s(index + 1))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "sort-title" },
                                            [_vm._v("教育经历")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "26px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                height: "auto",
                                                "justify-content":
                                                  "space-between",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "form-item",
                                                    staticStyle: {
                                                      "justify-content":
                                                        "flex-start",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "起始日期",
                                                          prop:
                                                            "educationList." +
                                                            index +
                                                            ".startTime",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请选择起始日期",
                                                              trigger: "change",
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c("el-date-picker", {
                                                          attrs: {
                                                            type: "date",
                                                            placeholder:
                                                              "请选择年/月/日",
                                                          },
                                                          model: {
                                                            value:
                                                              item.startTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "startTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.startTime",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "结束日期",
                                                          prop:
                                                            "educationList." +
                                                            index +
                                                            ".endTime",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请选择结束日期",
                                                              trigger: "change",
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c("el-date-picker", {
                                                          attrs: {
                                                            type: "date",
                                                            placeholder:
                                                              "请选择年/月/日",
                                                          },
                                                          model: {
                                                            value: item.endTime,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "endTime",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.endTime",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "学校名称",
                                                          prop:
                                                            "educationList." +
                                                            index +
                                                            ".institutionName",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请输入学校名称",
                                                              trigger: "blur",
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            clearable: "",
                                                            placeholder:
                                                              "请输入",
                                                          },
                                                          model: {
                                                            value:
                                                              item.institutionName,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "institutionName",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.institutionName",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "专业",
                                                          prop:
                                                            "educationList." +
                                                            index +
                                                            ".major",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请输入专业",
                                                              trigger: "blur",
                                                            },
                                                          ],
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _vm._v("专"),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "space",
                                                                  }),
                                                                  _vm._v("业"),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入",
                                                            maxlength: "12",
                                                            clearable: "",
                                                            "show-word-limit":
                                                              "",
                                                          },
                                                          model: {
                                                            value: item.major,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "major",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.major",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "学历",
                                                          prop:
                                                            "educationList." +
                                                            index +
                                                            ".educationalLevel",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请选择学历",
                                                              trigger: "change",
                                                            },
                                                          ],
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _vm._v("学"),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "space",
                                                                  }),
                                                                  _vm._v("历"),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择",
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                item.educationalLevel,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "educationalLevel",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.educationalLevel",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.dictionaries
                                                              .educational_level,
                                                            function (itm) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: itm.dictId,
                                                                  attrs: {
                                                                    label:
                                                                      itm.dictName,
                                                                    value:
                                                                      itm.dictId,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "教育类型",
                                                          prop:
                                                            "educationList." +
                                                            index +
                                                            ".educationalMode",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请选择教育类型",
                                                              trigger: "change",
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择",
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                item.educationalMode,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "educationalMode",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.educationalMode",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.dictionaries
                                                              .educational_mode,
                                                            function (itm) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: itm.dictId,
                                                                  attrs: {
                                                                    label:
                                                                      itm.dictName,
                                                                    value:
                                                                      itm.dictId,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              !_vm.isLook && index != 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "delete",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deletePlus(
                                                            2,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 删除")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              !_vm.isLook
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPlus(2)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                              staticStyle: { color: "#00B498" },
                                            }),
                                          ]),
                                          _c("div", { staticClass: "btn-t" }, [
                                            _vm._v("添加教育经历"),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "line" }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          ref: "anchor-3",
                          staticClass: "panel-item anchor-item",
                        },
                        [
                          _c("div", { staticClass: "panel-item-title" }, [
                            _vm._v("家庭信息"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "panel-item-content" },
                            [
                              _vm._l(
                                _vm.form.familyInfoList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: { "margin-bottom": "24px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sort-index" },
                                            [_vm._v(_vm._s(index + 1))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "sort-title" },
                                            [_vm._v("家庭成员")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "26px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                height: "auto",
                                                "justify-content":
                                                  "space-between",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  { staticClass: "form-item" },
                                                  [
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "本人关系",
                                                          prop:
                                                            "familyInfoList." +
                                                            index +
                                                            ".familyRelationships",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请选择学历",
                                                              trigger: "change",
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择",
                                                              clearable: "",
                                                            },
                                                            model: {
                                                              value:
                                                                item.familyRelationships,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    item,
                                                                    "familyRelationships",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "item.familyRelationships",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.dictionaries
                                                              .family_relationships,
                                                            function (itm) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: itm.dictId,
                                                                  attrs: {
                                                                    label:
                                                                      itm.dictName,
                                                                    value:
                                                                      itm.dictId,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "姓名",
                                                          prop:
                                                            "familyInfoList." +
                                                            index +
                                                            ".name",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请输入姓名",
                                                              trigger: "blur",
                                                            },
                                                          ],
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _vm._v("姓"),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "space",
                                                                  }),
                                                                  _vm._v("名"),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入",
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value: item.name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.name",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "工作单位",
                                                          prop:
                                                            "familyInfoList." +
                                                            index +
                                                            ".company",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请输入工作单位",
                                                              trigger: "blur",
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入",
                                                            clearable: "",
                                                            maxlength: "20",
                                                            "show-word-limit":
                                                              "",
                                                          },
                                                          model: {
                                                            value: item.company,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "company",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.company",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "职务",
                                                          prop:
                                                            "familyInfoList." +
                                                            index +
                                                            ".post",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请输入职务",
                                                              trigger: "blur",
                                                            },
                                                          ],
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "label",
                                                              fn: function () {
                                                                return [
                                                                  _vm._v("职"),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "space",
                                                                  }),
                                                                  _vm._v("务"),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入",
                                                            maxlength: "8",
                                                            clearable: "",
                                                            "show-word-limit":
                                                              "",
                                                          },
                                                          model: {
                                                            value: item.post,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "post",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.post",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-form-item",
                                                      {
                                                        attrs: {
                                                          label: "联系电话",
                                                          prop:
                                                            "familyInfoList." +
                                                            index +
                                                            ".phone",
                                                          rules: [
                                                            {
                                                              required: true,
                                                              message:
                                                                "请输入联系电话",
                                                              trigger: "blur",
                                                            },
                                                          ],
                                                        },
                                                      },
                                                      [
                                                        _c("el-input", {
                                                          attrs: {
                                                            placeholder:
                                                              "请输入",
                                                            maxlength: "11",
                                                            clearable: "",
                                                            "show-word-limit":
                                                              "",
                                                          },
                                                          model: {
                                                            value: item.phone,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "phone",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.phone",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]),
                                              !_vm.isLook && index != 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "delete",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deletePlus(
                                                            3,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 删除")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              !_vm.isLook
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPlus(3)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                              staticStyle: { color: "#00B498" },
                                            }),
                                          ]),
                                          _c("div", { staticClass: "btn-t" }, [
                                            _vm._v("添加家庭成员"),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "line" }),
                            ],
                            2
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          ref: "anchor-4",
                          staticClass: "panel-item anchor-item",
                        },
                        [
                          _c("div", { staticClass: "panel-item-title" }, [
                            _vm._v("培训经历"),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-weight": "400",
                                  "font-size": "16px",
                                  color: "#616363",
                                },
                              },
                              [_vm._v("（非必填项）")]
                            ),
                          ]),
                          _c(
                            "div",
                            { staticClass: "panel-item-content" },
                            [
                              _vm._l(
                                _vm.form.trainingInfoList,
                                function (item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticStyle: { "margin-bottom": "24px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "sort-index" },
                                            [_vm._v(_vm._s(index + 1))]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "sort-title" },
                                            [_vm._v("培训经历")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "26px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                height: "auto",
                                                "justify-content":
                                                  "space-between",
                                                position: "relative",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "起始日期",
                                                        prop:
                                                          "trainingInfoList." +
                                                          index +
                                                          ".startTime",
                                                        rules: [
                                                          {
                                                            required: false,
                                                            message: "",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        attrs: {
                                                          type: "date",
                                                          placeholder:
                                                            "请选择年/月/日",
                                                        },
                                                        model: {
                                                          value: item.startTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "startTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.startTime",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "结束日期",
                                                        prop:
                                                          "trainingInfoList." +
                                                          index +
                                                          ".endTime",
                                                        rules: [
                                                          {
                                                            required: false,
                                                            message: "",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-date-picker", {
                                                        attrs: {
                                                          type: "date",
                                                          placeholder:
                                                            "请选择年/月/日",
                                                        },
                                                        model: {
                                                          value: item.endTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "endTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.endTime",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "培训方式",
                                                        prop:
                                                          "trainingInfoList." +
                                                          index +
                                                          ".trainingMode",
                                                        rules: [
                                                          {
                                                            required: false,
                                                            message: "",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            placeholder:
                                                              "请选择",
                                                            clearable: "",
                                                          },
                                                          model: {
                                                            value:
                                                              item.trainingMode,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                item,
                                                                "trainingMode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.trainingMode",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.dictionaries
                                                            .training_mode,
                                                          function (itm) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: itm.dictId,
                                                                attrs: {
                                                                  label:
                                                                    itm.dictName,
                                                                  value:
                                                                    itm.dictId,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "培训机构",
                                                        prop:
                                                          "trainingInfoList." +
                                                          index +
                                                          ".institutionName",
                                                        rules: [
                                                          {
                                                            required: false,
                                                            message: "",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          placeholder: "请输入",
                                                          clearable: "",
                                                          maxlength: "16",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value:
                                                            item.institutionName,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "institutionName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.institutionName",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "获取证书",
                                                        prop:
                                                          "trainingInfoList." +
                                                          index +
                                                          ".certificate",
                                                        rules: [
                                                          {
                                                            required: false,
                                                            message: "",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          type: "textarea",
                                                          clearable: "",
                                                          placeholder: "请输入",
                                                          size: "medium",
                                                          rows: "3",
                                                          maxlength: "16",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value:
                                                            item.certificate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "certificate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.certificate",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "培训内容",
                                                        prop:
                                                          "trainingInfoList." +
                                                          index +
                                                          ".trainingContent",
                                                        rules: [
                                                          {
                                                            required: false,
                                                            message: "",
                                                            trigger: "blur",
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          type: "textarea",
                                                          clearable: "",
                                                          placeholder: "请输入",
                                                          size: "medium",
                                                          rows: "3",
                                                          maxlength: "64",
                                                          "show-word-limit": "",
                                                        },
                                                        model: {
                                                          value:
                                                            item.trainingContent,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "trainingContent",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.trainingContent",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              !_vm.isLook && index != 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "delete",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deletePlus(
                                                            4,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" 删除")]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              !_vm.isLook
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPlus(4)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                            "align-items": "center",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c("i", {
                                              staticClass: "el-icon-plus",
                                              staticStyle: { color: "#00B498" },
                                            }),
                                          ]),
                                          _c("div", { staticClass: "btn-t" }, [
                                            _vm._v("添加培训经历"),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("div", { staticStyle: { height: "40px" } }),
                ],
                1
              ),
              _c("transition", { attrs: { name: "el-fade-in" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.footer,
                        expression: "footer",
                      },
                    ],
                    staticClass: "panel-right",
                  },
                  [
                    _c(
                      "el-tabs",
                      {
                        staticClass: "vertical-tabs",
                        staticStyle: { height: "auto" },
                        attrs: { "tab-position": "right" },
                        on: { "tab-click": _vm.handleClickAchors },
                        model: {
                          value: _vm.activeBtn,
                          callback: function ($$v) {
                            _vm.activeBtn = $$v
                          },
                          expression: "activeBtn",
                        },
                      },
                      _vm._l(_vm.anchors, function (item, index) {
                        return _c("el-tab-pane", {
                          key: index,
                          attrs: { label: item.label, name: String(index) },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c("transition", { attrs: { name: "el-fade-in" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.footer,
                expression: "footer",
              },
            ],
            staticClass: "footer",
            class: [_vm.isCollapsed ? "footer-collapsed" : ""],
          },
          [
            _c(
              "div",
              {
                staticClass: "footer-btn-b",
                on: {
                  click: function ($event) {
                    return _vm.back()
                  },
                },
              },
              [_vm._v("返回")]
            ),
            !_vm.isLook
              ? _c(
                  "div",
                  {
                    staticClass: "footer-btn-r",
                    on: {
                      click: function ($event) {
                        return _vm.reset()
                      },
                    },
                  },
                  [_vm._v("重置")]
                )
              : _vm._e(),
            !_vm.isLook
              ? _c(
                  "div",
                  { staticClass: "footer-btn-s", on: { click: _vm.save } },
                  [_vm._v("确认")]
                )
              : _vm._e(),
          ]
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关联应聘信息",
            visible: _vm.isRelative,
            width: "978px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isRelative = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-body" }, [
            _c(
              "div",
              { staticClass: "dialog-title" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "form",
                    staticStyle: { width: "300px" },
                    attrs: {
                      inline: true,
                      model: _vm.form,
                      size: "small",
                      "label-width": "82px",
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "应聘信息联系电话" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "18px" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#F56C6C",
                                          "margin-right": "4px",
                                        },
                                      },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v("应聘信息联系电话 "),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "204px" },
                          attrs: {
                            placeholder: "请输入",
                            maxlength: "11",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticStyle: { width: "60px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("search")
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "dialog-line" }),
            _c("div", { staticClass: "dialog-content" }, [
              _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
                _c("div", { staticClass: "title-line" }),
                _c("div", { staticClass: "title-name" }, [_vm._v("查询结果")]),
              ]),
              _c("div", { staticClass: "dialog-main" }, [
                _c("div", { staticClass: "dialog-list" }),
              ]),
            ]),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isRelative = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isRelative = false
                    },
                  },
                },
                [_vm._v("关联")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "取消关联",
            visible: _vm.isNoRelative,
            width: "552px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isNoRelative = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-body" }, [
            _c(
              "div",
              { staticClass: "dialog-title" },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    staticClass: "form",
                    staticStyle: { "margin-left": "55px" },
                    attrs: {
                      inline: true,
                      model: _vm.form,
                      size: "small",
                      "label-width": "100px",
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "登录手机号" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "line-height": "32px" } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#F56C6C",
                                          "margin-right": "4px",
                                        },
                                      },
                                      [_vm._v("*")]
                                    ),
                                    _vm._v("登录手机号 "),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "204px" },
                          attrs: {
                            placeholder: "请输入",
                            maxlength: "11",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          width: "16px",
                          height: "16px",
                          "padding-top": "8px",
                          "padding-right": "2px",
                        },
                        attrs: {
                          src: require("../../../assets/icon_guanlian.png"),
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "32px",
                            "font-size": "14px",
                            color: "#00B498",
                          },
                          on: {
                            click: function ($event) {
                              _vm.isConfirm = true
                            },
                          },
                        },
                        [_vm._v("取消关联 ")]
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.isConfirm,
            width: "268px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isConfirm = $event
            },
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "14px",
                color: "#2F3030",
                "line-height": "22px",
                "text-align": "center",
                "margin-left": "12px",
              },
            },
            [_vm._v("是否确认取消关联应聘信息？")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.isConfirm = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isConfirm = false
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, "append-to-body": "" },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              fit: "contain",
              src: _vm.dialogImageUrl,
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }